export default "__VITE_ASSET__CCo7MYJv__"